import { render, staticRenderFns } from "./Die_together.vue?vue&type=template&id=c84e285a&scoped=true"
import script from "./Die_together.vue?vue&type=script&lang=js"
export * from "./Die_together.vue?vue&type=script&lang=js"
import style0 from "./Die_together.vue?vue&type=style&index=0&id=c84e285a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c84e285a",
  null
  
)

export default component.exports